<template>
  <v-container class="new-gate-page" fluid>
    <v-breadcrumbs :items="breadcrumbs" class="px-0 pt-0 pb-2" />
    <div class="new-gate-header">
      <h1 class="new-gate-header__title">{{ textTitle }}</h1>
      <v-btn
        color="primary"
        outlined
        class="new-gate-header__btn text-none"
        rounded
        @click.prevent="returnGates()"
      >
        <v-icon left>mdi-arrow-left</v-icon>
        К списку калиток
      </v-btn>
    </div>

    <v-card class="new-gate-card mt-3" flat outlined>
      <div class="new-gate-card__body pa-4">
        <div class="new-gate-type-row mb-4">
          <v-text-field
            label="Тип"
            v-model="typeGate"
            prepend-inner-icon="mdi-format-list-bulleted-type"
            outlined
            dense
            hide-details
            readonly
            class="new-gate-type-field"
          />
        </div>
        <NewGate />
      </div>
    </v-card>
  </v-container>
</template>

<script>
import NewGate from './components/NewGate';

export default {
  name: 'BaseFormNewGate',
  components: { NewGate },
  data () {
    return {
      typeGate: 'Калитка',
      breadcrumbs: [
        { text: 'Калитки', disabled: false, href: '/gates' },
        { text: 'Новая калитка', disabled: true, href: '#' },
      ],
    };
  },
  computed: {
    textTitle () {
      return 'Новая калитка';
    },
  },
  methods: {
    returnGates () {
      this.$router.push({ name: 'Gates' });
    },
  },
};
</script>

<style lang="scss" scoped>
.new-gate-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.new-gate-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.new-gate-header__btn {
  text-transform: none;
  font-weight: 500;
}

.new-gate-card {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.new-gate-type-row {
  max-width: 280px;
}

.new-gate-type-field {
  margin-bottom: 0;
}

@media screen and (max-width: 600px) {
  .new-gate-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .new-gate-header__title {
    font-size: 1.4rem;
  }
  .new-gate-type-row {
    max-width: 100%;
  }
}
</style>
